import { IGroupAdminState } from './types';

export const groupsAdminInitialState: IGroupAdminState = {
  id: '',
  storeUserId: '',
  email: '',
  name: '',
  password: '',
  groups: [{ storeGroup: { id: '', name: '' } }],
  allGroups: [
    {
      id: '',
      name: '',
    },
  ],
  list: {
    count: 0,
    items: [{ email: '', id: '', storeUserId: '', name: '', groupAdmin: [{ storeGroup: { id: '', name: '' } }] }],
  },
  filter: {
    name: '',
    storeGroupIds: [],
    page: 0,
    rowsPerPage: 5,
  },
};
